import styles from "./Table.module.css";
import React from "react";
import cn from "classnames";
import { Button } from "../Button/Button";
import { Icon } from "src/components/icon/icon";

interface Props {
  children: React.ReactNode;
  className?: string;
  pagination?: PaginationProps;
}

export const Section = (props: Props) => (
  <div className={cn(styles.container, props.className)}>
    <div className={styles.scroll}>
      <table className={styles.table}>{props.children}</table>
    </div>
    {props.pagination !== undefined && props.pagination.maxPageNumber > 1 && (
      <Pagination {...props.pagination} />
    )}
  </div>
);

export const Head = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <thead className={className}>{children}</thead>;
};

export const Body = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <tbody className={className}>{children}</tbody>;
};

interface PaginationProps {
  activePageNumber: number;
  maxPageNumber: number;
  onChange: (index: number) => void;
  paginationSize?: number;
}

export const Pagination = (props: PaginationProps) => {
  const { paginationSize = 3 } = props;

  // max paginationSize btns visible - active page should be in the middle
  const delta = Math.ceil(paginationSize / 2);
  const startPage = Math.max(
    props.activePageNumber -
      Math.max(delta - (props.maxPageNumber - props.activePageNumber), 1),
    1
  );

  const endPage = Math.min(
    startPage + (paginationSize - 1),
    props.maxPageNumber
  );

  const btns = [...Array(endPage - startPage + 1)].reduce<number[]>(
    (acc, _, index) => {
      acc.push(index + startPage);
      return acc;
    },
    []
  );

  return (
    <div className={cn(styles.pagination)}>
      <Button
        theme="ghost"
        size="S"
        disabled={props.activePageNumber === 1}
        className={cn(styles.paginationBtn)}
        onClick={() => props.onChange(props.activePageNumber - 1)}
      >
        <Icon icon="arrow-left" />
      </Button>
      {btns.map((pageNumber) => (
        <Button
          key={pageNumber}
          theme={props.activePageNumber === pageNumber ? "tertiary" : "ghost"}
          size="S"
          onClick={() => props.onChange(pageNumber)}
          className={cn(styles.paginationBtn)}
        >
          {pageNumber}
        </Button>
      ))}
      <Button
        theme="ghost"
        size="S"
        disabled={props.activePageNumber === props.maxPageNumber}
        className={cn(styles.paginationBtn)}
        onClick={() => props.onChange(props.activePageNumber + 1)}
      >
        <Icon icon="arrow-right" />
      </Button>
    </div>
  );
};
